<div class="points-page" [formGroup]="points">

  <!-- Back Button -->
  <div class="backButton" (click)="builderService.navigateBack()">
    <img src="/assets/icons/arrow-left.svg" [alt]="'Go back' | translate" />
  </div>

  <!-- Page Header -->
  <div class="page-header">
    <div class="header-left">
      <p class="page-title">{{ (currentSetupId && currentSetupId !== ':id' ? 'Edit Reward Rule' : 'Create Reward Rule') | translate }}</p>
      <p class="page-subtitle">{{ 'Set how customers earn and use rewards.' | translate }}</p>
    </div>
    <div class="header-right">
      <button type="button" class="cancel-btn" (click)="builderService.navigateBack()">
        <span>{{ 'Cancel' | translate }}</span>
      </button>
      <button type="submit" form="points" class="submit-btn" [disabled]="saving">
        <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.36589 0.699219V10.0326M0.699219 5.36589H10.0326" stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <span>{{ (currentSetupId && currentSetupId !== ':id' ? 'Update Reward' : 'Create Reward') | translate }}</span>
      </button>
    </div>
  </div>

  <!-- =============================== -->
  <!-- Earning Rules Card              -->
  <!-- =============================== -->
  <div class="section-card">
    <div class="card-header">
      <h3>{{ 'How Customers Earn Rewards' | translate }}</h3>
    </div>
    <div class="card-body">

      <!-- Fields row: Points For + Select + Earned Points -->
      <div class="fields-row">

        <!-- Points For -->
        <div class="field-wrapper">
          <div class="field-label-row">
            <label>{{ 'Reward Based On' | translate }}</label>
          </div>
          <div class="genie-input">
            <select formControlName="points_system" required>
              <option value="byOrder">{{ 'Order Total' | translate }}</option>
              <option value="byUnit">{{ 'Amount Spent' | translate }}</option>
              <option *ngIf="!this.vendor.isMultiVendor" value="byProductCategory">{{ 'Specific Products or Categories' | translate }}</option>
              <option value="byReferral">{{ 'Referral' | translate }}</option>
            </select>
          </div>
        </div>

        <!-- Select dropdown (shown for byOrder, byUnit, byProductCategory) -->
        <div class="field-wrapper" *ngIf="points.get('points_system')?.value === 'byOrder' || points.get('points_system')?.value === 'byUnit' || points.get('points_system')?.value === 'byProductCategory'">
          <div class="field-label-row">
            <label>{{ 'Apply To' | translate }}</label>
          </div>
          <div class="genie-input" *ngIf="points.get('points_system')?.value === 'byOrder'">
            <select formControlName="order_system" required>
              <option value="allProductsCategories">{{ 'Whole Cart' | translate }}</option>
              <option *ngIf="!this.vendor.isMultiVendor" value="selectedProduct">{{ 'Select Product' | translate }}</option>
              <option *ngIf="!this.vendor.isMultiVendor" value="selectedCategory">{{ 'Select Category' | translate }}</option>
            </select>
          </div>
          <div class="genie-input" *ngIf="points.get('points_system')?.value === 'byUnit'">
            <select formControlName="currency_system" required>
              <option value="currencyAll">{{ 'Whole Cart' | translate }}</option>
              <option *ngIf="!this.vendor.isMultiVendor" value="currency_product">{{ 'Select Product' | translate }}</option>
              <option *ngIf="!this.vendor.isMultiVendor" value="currency_category">{{ 'Select Category' | translate }}</option>
            </select>
          </div>
          <div class="genie-input" *ngIf="points.get('points_system')?.value === 'byProductCategory'">
            <select formControlName="product_option" required>
              <option value="allProductsCategories">{{ 'Whole Cart' | translate }}</option>
              <option value="choosenProduct">{{ 'Select Product' | translate }}</option>
              <option value="choosenCategory">{{ 'Select Category' | translate }}</option>
            </select>
          </div>
        </div>

        <!-- Earned Points (non-byUnit variants) -->
        <div class="field-wrapper" *ngIf="points.get('points_system')?.value !== 'byUnit' && !(points.get('points_system')?.value === 'byProductCategory' && (points.get('product_option')?.value === 'choosenProduct' || points.get('product_option')?.value === 'choosenCategory'))">
          <div class="field-label-row">
            <label>{{ 'Customer Earns' | translate }}</label>
          </div>
          <!-- byOrder - allProductsCategories -->
          <div class="input-with-suffix" *ngIf="points.get('points_system')?.value === 'byOrder' && points.get('order_system')?.value === 'allProductsCategories'">
            <div class="genie-input">
              <input type="number" formControlName="order_points" placeholder="0" [ngClass]="{ 'error-border': points.get('order_points')?.invalid && points.get('order_points')?.touched }" required />
            </div>
            <span class="input-suffix">{{ 'Points' | translate }}</span>
          </div>
          <!-- byOrder - selectedProduct -->
          <div class="input-with-suffix" *ngIf="points.get('points_system')?.value === 'byOrder' && points.get('order_system')?.value === 'selectedProduct'">
            <div class="genie-input">
              <input type="number" formControlName="order_checked_products_points" placeholder="0" [ngClass]="{ 'error-border': points.get('order_checked_products_points')?.invalid && points.get('order_checked_products_points')?.touched }" required />
            </div>
            <span class="input-suffix">{{ 'Points' | translate }}</span>
          </div>
          <!-- byOrder - selectedCategory -->
          <div class="input-with-suffix" *ngIf="points.get('points_system')?.value === 'byOrder' && points.get('order_system')?.value === 'selectedCategory'">
            <div class="genie-input">
              <input type="number" formControlName="order_checked_cats_points" placeholder="0" [ngClass]="{ 'error-border': points.get('order_checked_cats_points')?.invalid && points.get('order_checked_cats_points')?.touched }" required />
            </div>
            <span class="input-suffix">{{ 'Points' | translate }}</span>
          </div>
          <!-- byReferral -->
          <div class="input-with-suffix" *ngIf="points.get('points_system')?.value === 'byReferral'">
            <div class="genie-input">
              <input type="number" formControlName="referral_points" placeholder="0" [ngClass]="{ 'error-border': points.get('referral_points')?.invalid && points.get('referral_points')?.touched }" required />
            </div>
            <span class="input-suffix">{{ 'Points' | translate }}</span>
          </div>
          <!-- byProductCategory - allProductsCategories -->
          <div class="input-with-suffix" *ngIf="points.get('product_option')?.value === 'allProductsCategories' && points.get('points_system')?.value === 'byProductCategory'">
            <div class="genie-input">
              <input type="number" formControlName="product_points" placeholder="0" [ngClass]="{ 'error-border': points.get('product_points')?.invalid && points.get('product_points')?.touched }" required />
            </div>
            <span class="input-suffix">{{ 'Points' | translate }}</span>
          </div>
        </div>

        <!-- byUnit: currency + points row -->
        <div class="field-wrapper byunit-field" *ngIf="points.get('points_system')?.value === 'byUnit' && (points.get('currency_system')?.value === 'currencyAll' || points.get('currency_system')?.value === 'currency_product' || points.get('currency_system')?.value === 'currency_category')">
          <div class="field-label-row">
            <label>{{ 'Customer Earns' | translate }}</label>
          </div>
          <div class="currency-earned-row">
            <div class="genie-input unit-input">
              <input type="number" formControlName="units" placeholder="0" [ngClass]="{ 'error-border': points.get('units')?.invalid && points.get('units')?.touched }" required />
            </div>
            <span class="currency-assign-label">$ ({{ 'Currency' | translate }}) {{ 'Assign' | translate }}</span>
            <!-- currencyAll -->
            <div class="input-with-suffix" *ngIf="!(points.get('currency_system')?.value === 'currency_product' || points.get('currency_system')?.value === 'currency_category')">
              <div class="genie-input">
                <input type="number" formControlName="points" placeholder="0" [ngClass]="{ 'error-border': points.get('points')?.invalid && points.get('points')?.touched }" required />
              </div>
              <span class="input-suffix">{{ 'Points' | translate }}</span>
            </div>
            <!-- currency_product -->
            <div class="input-with-suffix" *ngIf="points.get('currency_system')?.value === 'currency_product' && points.get('points_system')?.value === 'byUnit'">
              <div class="genie-input">
                <input type="number" formControlName="currency_product_point" placeholder="0" [ngClass]="{ 'error-border': points.get('currency_product_point')?.invalid && points.get('currency_product_point')?.touched }" required />
              </div>
              <span class="input-suffix">{{ 'Points' | translate }}</span>
            </div>
            <!-- currency_category -->
            <div class="input-with-suffix" *ngIf="points.get('currency_system')?.value === 'currency_category' && points.get('points_system')?.value === 'byUnit'">
              <div class="genie-input">
                <input type="number" formControlName="currency_category_point" placeholder="0" [ngClass]="{ 'error-border': points.get('currency_category_point')?.invalid && points.get('currency_category_point')?.touched }" required />
              </div>
              <span class="input-suffix">{{ 'Points' | translate }}</span>
            </div>
          </div>
        </div>

      </div>

      <!-- Enable Points System Toggle -->
      <div class="toggle-row">
        <div class="toggle-info">
          <span class="toggle-label">{{ 'Enable Points System' | translate }}</span>
          <p class="toggle-desc">{{ 'Allow customers to earn and spend points on your store.' | translate }}</p>
        </div>
        <label class="toggle-switch">
          <input type="checkbox" formControlName="enable_points" />
          <span class="toggle-slider"></span>
        </label>
      </div>

    </div>
  </div>

  <!-- =============================== -->
  <!-- Products Table (conditional)    -->
  <!-- =============================== -->
  <div
    class="section-card table-card"
    *ngIf="
      (points.get('product_option')?.value === 'choosenProduct' && points.get('points_system')?.value === 'byProductCategory') ||
      (points.get('currency_system')?.value === 'currency_product' && points.get('points_system')?.value === 'byUnit') ||
      (points.get('order_system')?.value === 'selectedProduct' && points.get('points_system')?.value === 'byOrder')
    "
  >
    <div class="card-header card-header-with-action">
      <h3>{{ 'Products' | translate }}</h3>
      <div class="search-input-wrapper">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M5.75 10.5C8.37335 10.5 10.5 8.37335 10.5 5.75C10.5 3.12665 8.37335 1 5.75 1C3.12665 1 1 3.12665 1 5.75C1 8.37335 3.12665 10.5 5.75 10.5Z" stroke="#ADADAD" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M11 11L10 10" stroke="#ADADAD" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <input type="text" placeholder="{{ 'Search' | translate }}" id="searchInput" [(ngModel)]="searchText" [ngModelOptions]="{ standalone: true }" (ngModelChange)="applyFilter()" data-search />
      </div>
    </div>

    <div class="genie-table-wrapper">
      <table class="genie-table">
        <thead>
          <tr>
            <th>
              <mat-checkbox (change)="checkAll($event)" class="checkAllProductsCheckbox"></mat-checkbox>
              {{ 'Image' | translate }}
            </th>
            <th>{{ 'name' | translate }}</th>
            <th>{{ 'Sku' | translate }}</th>
            <th>{{ 'Stock' | translate }}</th>
            <th>{{ 'Price / Sale' | translate }}</th>
            <th>{{ 'Date' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let element of displayedProducts">
            <td class="image-cell">
              <mat-checkbox (change)="onItemChecked(element, $event, 'product')" [checked]="isChecked(element, 'product')"></mat-checkbox>
              <div class="productImgContainer">
                <img loading="lazy" [src]="element.imageUrl | primaryImage" class="image" />
              </div>
            </td>
            <td>{{ element.productName }}</td>
            <td>{{ element.productSKU }}</td>
            <td>{{ element.productStock >= 0 ? (element.productStock == 0 ? 'Out of Stock' : element.productStock) : 'InStock' }}</td>
            <td>{{ element.salePrice ? element.regularPrice + ' / ' + element.salePrice : element.regularPrice }}</td>
            <td>{{ element.date }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div class="genie-pagination">
      <div class="pagination-info">
        <span class="current-page">{{ pageIndex + 1 }}</span>
        <span class="page-separator">{{ 'of' | translate }}</span>
        <span class="total-pages">{{ totalProducts > 0 ? (totalProducts / pageSize | number:'1.0-0') : 1 }}</span>
      </div>
      <div class="pagination-controls">
        <button class="page-btn" [disabled]="pageIndex === 0" (click)="onPageChange({ pageIndex: pageIndex - 1, pageSize: pageSize, length: totalProducts })">
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M6.25 7.5L3.75 5L6.25 2.5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" /></svg>
        </button>
        <button class="page-btn" [disabled]="(pageIndex + 1) * pageSize >= totalProducts" (click)="onPageChange({ pageIndex: pageIndex + 1, pageSize: pageSize, length: totalProducts })">
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M3.75 7.5L6.25 5L3.75 2.5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" /></svg>
        </button>
      </div>
    </div>

    <!-- Selected Products -->
    <div *ngIf="selectedProducts.data.length > 0" class="selected-section">
      <h4 class="selected-title">{{ 'Selected Products' | translate }}</h4>
      <div class="genie-table-wrapper">
        <table class="genie-table">
          <thead>
            <tr>
              <th>{{ 'Image' | translate }}</th>
              <th>{{ 'Name' | translate }}</th>
              <th>{{ 'Sku' | translate }}</th>
              <th>{{ 'Stock' | translate }}</th>
              <th>{{ 'Price / Sale' | translate }}</th>
              <th>{{ 'Date' | translate }}</th>
              <th class="none" [ngClass]="{ show: points.get('product_option')?.value === 'choosenProduct' && points.get('points_system')?.value === 'byProductCategory' }">{{ 'points' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let element of selectedProducts.data">
              <td class="image-cell">
                <div class="productImgContainer">
                  <img loading="lazy" [src]="element.imageUrl | primaryImage" class="image" />
                </div>
              </td>
              <td>{{ element.productName }}</td>
              <td>{{ element.productSKU }}</td>
              <td>{{ element.productStock >= 0 ? (element.productStock == 0 ? 'Out of Stock' : element.productStock) : 'InStock' }}</td>
              <td>{{ element.salePrice ? element.regularPrice + ' / ' + element.salePrice : element.regularPrice }}</td>
              <td>{{ element.date }}</td>
              <td class="none" [ngClass]="{ show: points.get('product_option')?.value === 'choosenProduct' && points.get('points_system')?.value === 'byProductCategory' }">
                <ng-container *ngIf="!element.editing; else editPoints">
                  <div class="beforeEdit" (click)="editPoductPoints(element)">
                    <p>{{ element.points }}</p>
                    <span class="material-icons material-icons-outlined editIcon">edit</span>
                  </div>
                </ng-container>
                <ng-template #editPoints>
                  <input class="translateTextInput" type="number" [(ngModel)]="element.points" [ngModelOptions]="{ standalone: true }" (blur)="stopEdit(element)" (click)="$event.stopPropagation()" />
                </ng-template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- =============================== -->
  <!-- Categories Table (conditional)  -->
  <!-- =============================== -->
  <div
    class="section-card table-card"
    *ngIf="
      (points.get('currency_system')?.value === 'currency_category' && points.get('points_system')?.value === 'byUnit') ||
      (points.get('order_system')?.value === 'selectedCategory' && points.get('points_system')?.value === 'byOrder') ||
      (points.get('product_option')?.value === 'choosenCategory' && points.get('points_system')?.value === 'byProductCategory')
    "
  >
    <div class="card-header">
      <h3>{{ 'Categories' | translate }}</h3>
    </div>
    <div class="card-body categories-body">

      <!-- Category rows -->
      <div class="category-list">
        <div class="category-row" *ngFor="let cat of displayedCategories">
          <mat-checkbox (change)="onItemChecked(cat, $event, 'category')" [checked]="isChecked(cat, 'category')"></mat-checkbox>
          <img loading="lazy" [src]="cat.categoryImage || 'assets/images/empty-image.png'" class="cat-image" alt="" />
          <span class="cat-name">{{ cat.categoryName }}</span>
        </div>
      </div>

      <!-- Category Pagination -->
      <div class="genie-pagination">
        <div class="pagination-info">
          <span class="current-page">{{ categoryPageIndex + 1 }}</span>
          <span class="page-separator">{{ 'of' | translate }}</span>
          <span class="total-pages">{{ totalCategories > 0 ? (totalCategories / categoryPageSize | number:'1.0-0') : 1 }}</span>
        </div>
        <div class="pagination-controls">
          <button class="page-btn" [disabled]="categoryPageIndex === 0" (click)="onCategoryPageChange({ pageIndex: categoryPageIndex - 1, pageSize: categoryPageSize, length: totalCategories })">
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M6.25 7.5L3.75 5L6.25 2.5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" /></svg>
          </button>
          <button class="page-btn" [disabled]="(categoryPageIndex + 1) * categoryPageSize >= totalCategories" (click)="onCategoryPageChange({ pageIndex: categoryPageIndex + 1, pageSize: categoryPageSize, length: totalCategories })">
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M3.75 7.5L6.25 5L3.75 2.5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" /></svg>
          </button>
        </div>
      </div>

      <!-- Selected Categories -->
      <div *ngIf="selectedCategories.length > 0" class="selected-section">
        <h4 class="selected-title">{{ 'Selected Categories' | translate }}</h4>
        <div class="category-list">
          <div class="category-expandable" *ngFor="let cat of selectedCategories">
            <div class="category-row cat-selected-row">
              <img loading="lazy" [src]="cat.categoryImage || 'assets/images/empty-image.png'" class="cat-image" alt="" />
              <span class="cat-name">{{ cat.categoryName }}</span>
              <button
                type="button"
                class="cat-expand-btn"
                *ngIf="points.get('product_option')?.value === 'choosenCategory' && points.get('points_system')?.value === 'byProductCategory'"
                (click)="cat._expanded = !cat._expanded"
              >
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" [style.transform]="cat._expanded ? 'rotate(180deg)' : 'rotate(0deg)'">
                  <path d="M9.95906 4.47461L6.69906 7.73461C6.31406 8.11961 5.68406 8.11961 5.29906 7.73461L2.03906 4.47461" stroke="#ADADAD" stroke-width="0.75" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
            </div>
            <div class="cat-points-section" *ngIf="cat._expanded && points.get('product_option')?.value === 'choosenCategory' && points.get('points_system')?.value === 'byProductCategory'">
              <div class="field-wrapper">
                <div class="field-label-row">
                  <label>{{ 'points' | translate }}</label>
                </div>
                <div class="genie-input cat-points-input">
                  <input type="number" [(ngModel)]="cat.points" [ngModelOptions]="{ standalone: true }" placeholder="0" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- =============================== -->
  <!-- Redemption & Validity Card      -->
  <!-- =============================== -->
  <div class="section-card">
    <div class="card-header">
      <h3>{{ 'How Rewards Work' | translate }}</h3>
    </div>
    <div class="card-body">

      <!-- Points + Equals Currency + Min Order Amount -->
      <div class="fields-row">
        <div class="field-wrapper">
          <div class="field-label-row">
            <label>{{ 'Points Needed' | translate }}</label>
          </div>
          <div class="genie-input">
            <input type="number" formControlName="redeem_points" [ngClass]="{ 'error-border': points.get('redeem_points')?.invalid && points.get('redeem_points')?.touched }" placeholder="100" required />
          </div>
        </div>
        <div class="field-wrapper">
          <div class="field-label-row">
            <label>{{ 'Discount Value' | translate }}</label>
          </div>
          <div class="genie-input">
            <input type="number" formControlName="redeem_currency" [ngClass]="{ 'error-border': points.get('redeem_currency')?.invalid && points.get('redeem_currency')?.touched }" placeholder="20" required />
          </div>
        </div>
        <div class="field-wrapper">
          <div class="field-label-row">
            <label>{{ 'Minimum Order to Use Reward' | translate }}</label>
          </div>
          <div class="genie-input">
            <input type="number" formControlName="min_redeem" [ngClass]="{ 'error-border': points.get('min_redeem')?.invalid && points.get('min_redeem')?.touched }" placeholder="50" required />
          </div>
        </div>
      </div>

      <!-- Validity Period -->
      <div class="field-wrapper validity-field">
        <div class="field-label-row">
          <label>{{ 'Reward Expiry' | translate }}</label>
        </div>
        <div class="input-with-suffix">
          <div class="genie-input validity-input">
            <input type="number" formControlName="validity_date" [ngClass]="{ 'error-border': points.get('validity_date')?.invalid && points.get('validity_date')?.touched }" placeholder="365" required />
          </div>
          <span class="input-suffix">{{ 'Days' | translate }}</span>
        </div>
      </div>

      <!-- Remove Points When Order Cancelled Toggle -->
      <div class="toggle-row" *ngIf="points.get('points_system')?.value !== 'byReferral'">
        <div class="toggle-info">
          <span class="toggle-label">{{ 'Remove Rewards if Order is Cancelled' | translate }}</span>
          <p class="toggle-desc">{{ 'Rewards will be removed if the order is cancelled or refunded.' | translate }}</p>
        </div>
        <label class="toggle-switch">
          <input type="checkbox" formControlName="order_cancelation" />
          <span class="toggle-slider"></span>
        </label>
      </div>

    </div>
  </div>

  <!-- =============================== -->
  <!-- Referral App Links (conditional) -->
  <!-- =============================== -->
  <div class="section-card" *ngIf="points.get('points_system')?.value === 'byReferral'">
    <div class="card-header">
      <h3>{{ 'App Store Links' | translate }}</h3>
    </div>
    <div class="card-body">
      <div class="fields-row">
        <div class="field-wrapper">
          <div class="field-label-row">
            <label>{{ 'Play Google' | translate }}</label>
          </div>
          <div class="genie-input">
            <input type="text" formControlName="playStore" [ngClass]="{ 'error-border': points.get('playStore')?.invalid && points.get('playStore')?.touched }" placeholder="play.google.com" required />
          </div>
        </div>
        <div class="field-wrapper">
          <div class="field-label-row">
            <label>{{ 'Apple Store' | translate }}</label>
          </div>
          <div class="genie-input">
            <input type="text" formControlName="appleStore" [ngClass]="{ 'error-border': points.get('appleStore')?.invalid && points.get('appleStore')?.touched }" placeholder="apps.apple.com" required />
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

<form id="points" (ngSubmit)="saveChanges()"></form>
